import {
	GdsServiceFragment,
	OrderAdditionalServiceGdsServiceServiceType,
	GdsService_OrderAdditionalServiceGdsServiceMisc_Fragment as MiscServiceFragment
} from '@websky/graphql';
import { CardExtraFilter } from '../../../../CardExtra/types';

export interface MiscServiceGroup {
	key: string;
	filter: CardExtraFilter;
	groupServices: { filter: CardExtraFilter }[];
}

export function getMiscServiceGroups(services: GdsServiceFragment[]): MiscServiceGroup[] {
	const miscServicesGroups = new Map<string, Set<string>>();

	for (const service of services) {
		if (service.type !== OrderAdditionalServiceGdsServiceServiceType.Misc) {
			continue;
		}

		const miscService = service as MiscServiceFragment;
		const key = miscService.subtype?.title ?? service.rfisc;

		const servicesRfiscSet = miscServicesGroups.get(key) ?? new Set<string>();
		servicesRfiscSet.add(service.rfisc);

		miscServicesGroups.set(key, servicesRfiscSet);
	}

	return [...miscServicesGroups.values()].map(servicesRfiscSet => {
		const miscServicesRfiscs = [...servicesRfiscSet];
		const isGroup = miscServicesRfiscs.length > 1;

		return {
			key: miscServicesRfiscs[0],
			filter: { param: 'rfisc', values: isGroup ? miscServicesRfiscs : [miscServicesRfiscs[0]] },
			groupServices: isGroup
				? miscServicesRfiscs.map(rfisc => ({ filter: { param: 'rfisc', values: [rfisc] } }))
				: []
		};
	});
}
